export default __webpack_public_path__ + "static/media/stars.2e913d64.png";